/** n as a whole-number percentage of total (0 when there is no total) */
export const pct = (n: number, total: number) => (total ? Math.round((n / total) * 100) : 0);
